import React from 'react';
import {Grid,Typography, Dialog,IconButton,useTheme,useMediaQuery
} from '@mui/material'
import { green } from '@mui/material/colors';
import { useEffect } from 'react';
import {makeStyles} from '@mui/styles'
import Iconify from '../../../components/iconify';


/**
 * @module Layouts/Registration/modals/DocumentModal
 * @description The function defines a modal component that displays a file's description and content in an iframe.
 */

/**
 * 
 * @typedef DocumentModal
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Boolean} open - Variables that handles if this component is shown or not
 * @property {Array<Object>} file - Agreement's Document with the URL of the file
 * @return A React functional component that renders a Dialog component with a title, close button,
 * and an iframe that displays a file's URL. The component receives props such as `open`, `onClose`,
 * and `file`. It also uses Material-UI hooks such as `useStyles` and `useTheme`.
 
 */
const DocumentModal = (props) => {

    const classes = useStyles()
    const {open, onClose, file} = props

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    useEffect(() => {
        if(open){

            //setSelected(addresses[0])
        }
    }, [open, ])

    const onInnerClose = () => {
        //onResetForm()
        onClose()
    }




    return ( 
        <Dialog open={open} onClose={onInnerClose} fullScreen={isMobile} maxWidth={'md'} fullWidth scroll='body'>
            <div className={classes.root}>
                <Grid container justifyContent='center' spacing={1} alignItems='center'>
                    <Grid item xs>
                        <Typography variant='subtitle1' className={classes.title}>{file?.description}</Typography>
                    </Grid>
                    <Grid item>
                        <IconButton className={classes.close_button} onClick={onClose} >
                            <Iconify icon="ic:baseline-close" />
                        </IconButton>
                    </Grid>
                </Grid>
                <div className={classes.content}>
                   {file && file?.url ? (
                        <iframe src={file?.url} style={{width:'100%', height:'98%'}}/>
                   ): null}
                </div>
            </div>
        </Dialog>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        //paddingTop:30
    },
    content:{
        width:'100%',
        height:'calc(100vh - 50px)',background:'grey'
    },
    title:{
        paddingLeft:8,
        fontWeight:600,
    },
    icon_container:{
        width:80,
        height:80,
        borderRadius:'50%',
        border:`1px solid ${green[700]}`,
        position:'relative'
    },
    icon:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)',
        color:green[700],
        fontSize:48
    },
    menu:{
        margin:'16px 0px'
    }
}))
 
export default DocumentModal;